import { Box, Container, Flex, Text, Title } from "@mantine/core";

export default function AboutHeroSection() {
  return (
    <Box style={{ background: "linear-gradient(to bottom, #FFFFFF, #F1F7FF)" }} py={{ base: "xl", sm: "50", md: "60" }}>
      <Container size="lg" px={{ base: "md", sm: "xl" }}>
        <Flex direction="column" align="center" gap="xs">
          <Title order={1} ta="center" fz={{ base: "28px", sm: "34px", md: "40px" }} px={{ base: "md", sm: 0 }}>
            About GT Setu
          </Title>
          <Text ta="center" maw={650} fz={{ base: "sm", sm: "sm", md: "md" }} px={{ base: "md", sm: "xl", md: 0 }}>
            Building the world's most trusted global business network through compliance-backed verification and secure
            collaboration.
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}
